export function validAmazonTarget(target) {
  if (!target || typeof target.name !== 'string' || !target.name.trim() || typeof target.href !== 'string') return false;
  try {
    const u = new URL(target.href);
    return u.protocol === 'https:' && u.hostname === 'www.amazon.com' && !u.username && !u.password && !u.port && !u.hash &&
      /^\/dp\/[A-Z0-9]{10}(?:\/ref=nosim)?$/.test(u.pathname) &&
      [...u.searchParams.keys()].length === 1 && u.searchParams.getAll('tag').length === 1 && u.searchParams.get('tag') === 'moregosu-20';
  } catch { return false; }
}
export function eligibleTargets(targets, existingHrefs) {
  if (!Array.isArray(targets) || !targets.length || targets.length > 6 || !targets.every(validAmazonTarget)) return [];
  const unique = new Set(targets.map(t => t.href));
  if (unique.size !== targets.length || !targets.every(t => existingHrefs.includes(t.href))) return [];
  return targets;
}
export function shouldShow({dismissed, topPassed, blocked, focused, belowArticle}) {
  return !dismissed && !blocked && (focused || (topPassed && !belowArticle));
}
if (typeof window !== 'undefined' && !customElements.get('mg-floating-amazon')) {
  customElements.define('mg-floating-amazon', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const main = this.closest('.mg-native-main');
      const body = main?.querySelector('.editorial-body');
      if (!body) return;
      const anchors = [...body.querySelectorAll('a[href]')];
      let targets;
      try { targets = eligibleTargets(JSON.parse(this.querySelector('[data-targets]').textContent), anchors.map(a => a.href)); } catch { return; }
      if (!targets.length) return;
      const v2Top = main.closest('[data-mg-guide-version="2"]')?.querySelector('[data-mg-v2-top-cta]');
      const top = v2Top || anchors.find(a => targets.some(t => t.href === a.href) && a.textContent.trim());
      if (!top) return;
      const rail = this.querySelector('[data-rail]');
      const toggle = this.querySelector('[data-toggle]');
      const single = this.querySelector('[data-single]');
      const choices = this.querySelector('[data-choices]');
      const products = this.querySelector('[data-products]');
      products.replaceChildren();
      const spacer = this.querySelector('[data-spacer]');
      const newTab = this.querySelector('[data-new-tab]').textContent;
      const closeChoices = () => { choices.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
      if (targets.length === 1) {
        single.href = targets[0].href;
        single.setAttribute('aria-label', `${single.textContent.trim()}: ${targets[0].name}`);
        single.hidden = false;
      } else {
        for (const target of targets) {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = target.href; link.target = '_blank'; link.rel = 'sponsored noopener';
          link.textContent = target.name + ' ';
          const externalArrow = document.createElement('span');
          externalArrow.className = 'mg-amazon-external';
          externalArrow.setAttribute('aria-hidden', 'true');
          link.append(externalArrow);
          link.setAttribute('aria-label', `${target.name} ${newTab}`);
          li.append(link); products.append(li);
        }
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          choices.hidden = !choices.hidden;
          toggle.setAttribute('aria-expanded', String(!choices.hidden));
          if (!choices.hidden) products.querySelector('a')?.focus();
        }, {signal});
      }
      let dismissed = false;
      const returnFocus = () => {
        const had = main.hasAttribute('tabindex');
        if (!had) main.setAttribute('tabindex', '-1');
        main.focus({preventScroll: true});
        if (!had) main.addEventListener('blur', () => main.removeAttribute('tabindex'), {once:true});
      };
      const dismiss = () => {
        dismissed = true; closeChoices();
        if (rail.contains(document.activeElement)) returnFocus();
        rail.hidden = true; spacer.style.height = '0px';
      };
      this.querySelector('[data-close]').addEventListener('click', dismiss, {signal});
      rail.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        if (!choices.hidden) { closeChoices(); toggle.focus(); } else dismiss();
      }, {signal});
      document.addEventListener('pointerdown', event => {
        if (!rail.contains(event.target)) closeChoices();
      }, {signal});
      const visible = element => {
        const r = element.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
      };
      const update = () => {
        this.frame = null;
        if (dismissed) return;
        const headerBottom = Math.max(0, document.querySelector('#header-component')?.getBoundingClientRect().bottom || 0);
        const active = document.activeElement;
        const editing = active && !rail.contains(active) && active.matches('input, textarea, select, [contenteditable="true"]');
        const blockers = document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .moregosu-footer, footer, .mg-departure-check, .mg-checklist, [data-mg-related-guides]');
        const blocked = Boolean(editing) || [...blockers].some(visible);
        const focused = rail.contains(active);
        const show = shouldShow({dismissed, topPassed:top.getBoundingClientRect().bottom < headerBottom, blocked, focused, belowArticle:body.getBoundingClientRect().bottom < window.innerHeight - 100});
        if (!show && focused) returnFocus();
        rail.hidden = !show;
        if (!show) closeChoices();
      };
      const queue = () => { if (this.frame == null) this.frame = requestAnimationFrame(update); };
      spacer.style.height = '120px';
      document.addEventListener('scroll', queue, {capture:true, passive:true, signal});
      window.addEventListener('resize', queue, {passive:true, signal});
      for (const type of ['focusin','focusout','toggle','click']) document.addEventListener(type, queue, {signal});
      window.visualViewport?.addEventListener('resize', queue, {signal});
      this.observer = new ResizeObserver(queue); this.observer.observe(body);
      this.modalObserver = new MutationObserver(queue);
      this.modalObserver.observe(document.body, {subtree:true, attributes:true, attributeFilter:['open', 'aria-hidden']});
      queue();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.modalObserver?.disconnect(); if (this.frame != null) cancelAnimationFrame(this.frame); this.ready = false; }
  });
}
